import { motion } from "framer-motion"
import useWindowDimensions from "../utils/useWindowDimensions"
import { StaticImage } from "gatsby-plugin-image"

export const PoweringBrands = ({ isDemoPage = false }) => {
  const { width } = useWindowDimensions()
  const isMobileUp = width >= 768

  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.25,
      },
    },
  }

  const logo = {
    hidden: {
      opacity: 0,
      y: 10,
      filter: "blur(10px)",
    },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        duration: 1,
        ease: [0.33, 1, 0.68, 1],
      },
    },
  }

  if (isDemoPage) {
    return (
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="py-8"
      >
        {isMobileUp && (
          <motion.span
            variants={logo}
            className="text-sm font-medium text-gray-500 block w-full md:w-auto md:block w-full mb-4"
          >
            Powering <b>2000+</b> events worldwide.
          </motion.span>
        )}

        <div className="grid grid-cols-4">
          {" "}
          <motion.div
            variants={logo}
            className="flex items-center justify-start"
          >
            <StaticImage
              src="../images/client-logos/latest/gitex.png"
              alt="GITEX"
              className="w-12 md:w-20 h-auto"
            />
          </motion.div>
          <motion.div
            variants={logo}
            className="flex items-center justify-center"
          >
            <StaticImage
              src="../images/client-logos/latest/informa.png"
              alt="Informa"
              className="w-28 md:w-[160px] h-auto"
            />
          </motion.div>
          <motion.div
            variants={logo}
            className="flex items-center justify-center"
          >
            <StaticImage
              src="../images/client-logos/latest/idc.png"
              alt="IDC"
              className="w-12 md:w-[80px] h-auto"
            />
          </motion.div>
          <motion.div
            variants={logo}
            className="flex items-center justify-center"
          >
            <StaticImage
              src="../images/client-logos/latest/dmg.svg"
              alt="G2"
              className="w-20 md:w-28 h-auto "
            />
          </motion.div>
        </div>
      </motion.div>
    )
  }

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="mt-8 grid grid-cols-4 md:flex flex-wrap items-center justify-center gap-4 md:gap-8"
    >
      {isMobileUp && (
        <motion.span
          variants={logo}
          className="text-sm font-medium text-gray-500 block w-full md:w-auto md:inline"
        >
          Powering
        </motion.span>
      )}

      <motion.div variants={logo} className="flex items-center justify-center">
        <StaticImage
          src="../images/client-logos/latest/gitex.png"
          alt="GITEX"
          className="w-12 md:w-20 h-auto"
        />
      </motion.div>

      <motion.div variants={logo} className="flex items-center justify-center">
        <StaticImage
          src="../images/client-logos/latest/informa.png"
          alt="Informa"
          className="w-28 md:w-[160px] h-auto"
        />
      </motion.div>

      <motion.div variants={logo} className="flex items-center justify-center">
        <StaticImage
          src="../images/client-logos/latest/idc.png"
          alt="IDC"
          className="w-12 md:w-[80px] h-auto"
        />
      </motion.div>

      <motion.div variants={logo} className="flex items-center justify-center">
        <StaticImage
          src="../images/client-logos/latest/dmg.svg"
          alt="G2"
          className="w-20 md:w-28 h-auto "
        />
      </motion.div>

      {isMobileUp && (
        <motion.span
          variants={logo}
          className="text-sm font-medium text-gray-500 block md:inline w-full md:w-auto"
        >
          and <b>2000+</b> events worldwide.
        </motion.span>
      )}
    </motion.div>
  )
}
